<script lang="ts">
    import { createEventDispatcher } from 'svelte'
    import { get_current_component } from 'svelte/internal'
    const component = get_current_component()
    const svelteDispatch = createEventDispatcher()
    import { writable } from 'svelte/store'
    import { navKeyForPath } from '../../modules/usersApi/statistics/statistics-nav-keys'

    export const globalError = writable(null)

    window.error = (error: any) => {
        globalError.update((_) => error)
    }

    let localError

    globalError.subscribe((value) => {
        localError = value
    })

    let arrayErrors = []
    $: {
        evaluateError(localError)
    }

    function convertErrorToArray(error) {
        if (!error) {
            return []
        }
        if (typeof error === 'string') {
            return [error]
        }
        if (Array.isArray(error)) {
            return error
        }
        if (typeof error === 'object') {
            if (error.message) {
                if (typeof error.message === 'string') {
                    return [error.message]
                }
                if (Array.isArray(error.message)) {
                    return error.message
                }
                // erro aninhado (ex: { message: { message: '...' } }) — evita cair no fallback genérico abaixo
                if (typeof error.message === 'object' && typeof error.message.message === 'string') {
                    return [error.message.message]
                }
            }
            // nunca expor o objeto cru ao usuário (viraria "[object Object]") — loga pra investigação e mostra algo acionável
            console.log('error sem mensagem legível', error)
            return ['Ocorreu um erro inesperado. Tente novamente ou contate o suporte caso persista.']
        }
        console.log('error not evaluated', error)
    }

    async function evaluateError(error) {
        let arrError = convertErrorToArray(error)
        if (arrError.length > 0) {
            tickErrorStat(arrError[0])
            if (arrError[0].includes('Unauthorized') && !location.href.includes('/login')) {
                console.log(location.href)
                location.href = '/login'
            }
        }

        arrayErrors = await humanizeError(arrError)
    }

    // reaproveita os mesmos padrões de texto já usados acima (roteamento pro /login, humanizeText) —
    // key por categoria, nunca a mensagem crua, pra não estourar cardinalidade na tabela de estatísticas.
    function tickErrorStat(message: string) {
        try {
            if (message.includes('Unauthorized') || message.includes('Not authorized')) {
                window.api.users.statistics.tick('error.401')
            } else if (message.includes('Failed to fetch') || message.includes('Load failed') || message.includes('NetworkError')) {
                window.api.users.statistics.tick('error.network')
            } else {
                window.api.users.statistics.tick('error.app')
                // além do total, onde doeu: reusa o mapa de rotas do nav.* para manter a cardinalidade
                // fechada (~30 valores). error.app continua sendo o total, para não quebrar o painel.
                const navKey = navKeyForPath(location.pathname)
                if (navKey) window.api.users.statistics.tick('error.app.' + navKey.replace('nav.', ''))
            }
        } catch (error) {}
    }

    async function humanizeError(arrError: string[]) {
        for (let index = arrError.length - 1; index >= 0; index--) {
            const hum = await humanizeText(arrError[index])
            arrError[index] = hum
            const foundRep = arrError.filter((el) => el === hum).length
            if (foundRep > 1) {
                arrError.splice(index, 1)
            }
        }
        return arrError
    }

    async function humanizeText(message: string) {
        // erros de não autorização translateerror message
        try {
            if (message === 'Not authorized (4)') {
                return 'Senha incorreta.\nVerifique a senha informada.\nVerifique maiúsculas e minúsculas.'
            }
            if (message.includes('Not authorized')) {
                return 'Acesso não autorizado. Verifique o login.\n' + '(' + message + ')'
            }
            if (message === 'User not found (1)') {
                return 'O usuário informado não existe.\nVerifique se você digitou o celular ou e-mail corretamente.'
            }
            if (message === 'Not authorized. No password. Please create a password.') {
                return 'Este usuário ainda não possui uma senha.\nClique em "Esqueci minha senha" e receba um SMS para entrar.'
            }
            if (message.includes('should not be empty')) {
                return 'Todos os campos obrigatórios devem ser preenchidos.'
            }
            if (message.includes('already registered. userId')) {
                return 'Este telefone já está sendo utilizado.\nCaso não se lembre da senha tente recuperar na tela de login.'
            }
            if (message.includes('already signed')) {
                return 'Este documento já foi assinado.'
            }
            if (message.includes('Signature is invalid')) {
                return 'Assinatura inválida.'
            }
            if (message.includes('Signature is required')) {
                return 'Assinatura é obrigatória.'
            }
            if (message.includes('Automation limit reached.')) {
                return 'Limite máximo de automações atingido.\nPara criar novas automações primeiro exclua uma existente.'
            }
            if (message.includes('Incorrect old password')) {
                return 'A senha ATUAL está incorreta.'
            }
            if (message.includes('User cashier is already opened')) {
                return 'Já existe um caixa aberto para o usuário atual.'
            }
            if (message.includes('This cashier is closed')) {
                return 'O caixa deste lançamento está fechado. Não é possível alterar.'
            }
            if (message.includes('Token not allowed for this company')) {
                return 'Acesso não autorizado à esta empresa.'
            }
            if (message.includes('The card verification failed')) {
                return 'Erro ao validar o cartão. Confira se todos os dados estão corretos e se o cartão está ativo.'
            }
            if (message.includes('phone must be longer than or equal')) {
                return 'Informe um telefone válido'
            }
            if (message.includes('Failed to fetch') || message.includes('Load failed') || message.includes('NetworkError')) {
                const netStatus = await window.api.utils.internet.check(undefined, 3, 500, 1000)
                if (!netStatus.stability) {
                    return (
                        'Erro de conexão. Verifique sua internet (1).\nApós restabelecer atualize a tela.\nEstabilidade da Internet: ' +
                        netStatus.level.toFixed(0) +
                        '%'
                    )
                }
                return 'Erro ao conectar com o servidor (1).\nPode ter ocorrido uma instabilidade temporária nos servidores do Zandu.\nTente novamente.'
            }
            //
            console.log('message-not-hum', message)
        } catch (error) {
            return message
        }

        return message
    }

    function closePopup() {
        globalError.set(null)
        // //if (close) close()
        // svelteDispatch('close', null)
        // component?.dispatchEvent(new CustomEvent('close', null))
    }
</script>

{#if arrayErrors?.length > 0}
    <div class="root-alert">
        <div class="box">
            <div class="title">Erro</div>
            {#if arrayErrors.length === 1}
                <div class="errors">
                    {arrayErrors[0]}
                </div>
            {:else}
                <ul class="errors">
                    {#each arrayErrors as error}
                        <li>{error}</li>
                    {/each}
                </ul>
            {/if}
            <button on:click={closePopup}>Ok</button>
        </div>
    </div>
{/if}

<style>
    .root-alert {
        top: 0px;
        left: 0px;
        position: fixed;
        padding: 8px;
        z-index: 9999;
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100vh;
        width: 100vw;
        background: #000000aa;
    }
    .root-alert .box {
        min-width: 340px;
        max-width: 600px;
        display: flex;
        justify-content: center;
        flex-direction: column;
        background: #282828;
        border-radius: 4px;
        border: 1px solid #ff8888;
        color: #ccc;
        box-shadow: 0px 6px 8px 0px #00000060;
    }

    .root-alert .title {
        padding: 16px 16px 8px 16px;
        font-size: 18px;
        color: #fff;
    }
    .root-alert .errors {
        overflow-y: auto;
        padding: 0px 16px 24px 16px;
    }
    .root-alert .errors > * {
        margin-bottom: 4px;
    }
    .root-alert button {
        width: fit-content;
        padding: 6px 36px;
        margin: 16px auto;
        border-radius: 4px;
    }
    .root-alert ul {
        margin: 0px;
    }
</style>
